const modalStore = {
  namespaced: true,
  state: () => ({
    isLoading: false,
    profile: false,
    advanceSearch: false,
    kbli: false,
    iujp: false,
    sbujk: false,
    iujptl: false,
    inubbm: false,
    siupal: false,

    category: true,
    categoryMobile: false,
    modalTicketNewVendor: false,
  }),
  mutations: {
    openModal(state, payload) {
      state[payload.name] = true
    },
    closeModal(state, payload) {
      state[payload.name] = false
    },
    setValue(state, payload) {
      state[payload.name] = payload.value
    },
  },
  actions: {},
}

export default modalStore
